import Field from 'components/Form/Field';
import FormHeader from 'components/Form/FormHeader';
import KeyValue from 'components/Layout/KeyValue';
import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import TooltipWrapper from 'components/Tooltip';
import Value from 'components/Value';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {jstDateString, jstDateTimeString} from 'utils/date';

import {DocumentArchiveBackend} from './types';

const FieldsLeft: FC = () => {
    const {
        data: {document},
    } = useBackend<DocumentArchiveBackend>();

    return (
        <>
            <Field label={t`Document`} type="value">
                <span>
                    {document.displayName}
                    <TooltipWrapper
                        message={document.permissions.canView.failureReason}
                    >
                        <LinkButton
                            className="ml-2"
                            disabled={!document.permissions.canView.allowed}
                            href={document.url}
                            kind="secondary"
                            size="xs"
                            target="_blank"
                        >
                            {t`View PDF`}
                        </LinkButton>
                    </TooltipWrapper>
                </span>
            </Field>
            <Field label={t`(Transaction) Date`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: jstDateString(document.dateIssued),
                    }}
                />
            </Field>
            <Field label={t`Client`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.clientName,
                    }}
                />
            </Field>
            <Field label={t`Total`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.total,
                    }}
                />
            </Field>
            <Field label={t`Document External ID`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.externalId || '—',
                    }}
                />
            </Field>
        </>
    );
};

const FieldsRight: FC = () => {
    const {
        data: {document},
    } = useBackend<DocumentArchiveBackend>();

    return (
        <>
            <Field label={t`Archived at`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: jstDateTimeString(document.dateSent),
                    }}
                />
            </Field>
            <Field label={t`Sender`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.employee,
                    }}
                />
            </Field>
            <Field label={t`Delivery Methods`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.deliveryMethods.join(', '),
                    }}
                />
            </Field>
            <Field label={t`Legal Delivery Categories`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: document.legalCategories.join(', '),
                    }}
                />
            </Field>
        </>
    );
};

const DocumentArchiveItemPage: FC = () => {
    const {appPermissions} = useBackend<DocumentArchiveBackend>();

    return (
        <div className="flex flex-col">
            <NavigationTabs.History
                permissions={appPermissions}
                selection="documentArchive"
            />
            <FormHeader title={t`Issued Document Details`} />
            <div className="mt-4 flex flex-row text-base">
                <div className="min-w-0 flex-1 flex-col">
                    <KeyValue>
                        <FieldsLeft />
                    </KeyValue>
                </div>
                <div className="min-w-0 flex-1 flex-col">
                    <KeyValue>
                        <FieldsRight />
                    </KeyValue>
                </div>
            </div>
        </div>
    );
};

export default DocumentArchiveItemPage;
